// extracted by mini-css-extract-plugin
export var root = "dealers-map-module--root--20b58";